__turbopack_context__.v({
  "dividerLine": "KVD8uW_dividerLine",
  "flexContainer": "KVD8uW_flexContainer",
  "flightsInformationText": "KVD8uW_flightsInformationText",
  "group": "KVD8uW_group",
  "oneClickLuggageBulletListItem": "KVD8uW_oneClickLuggageBulletListItem",
  "oneClickLuggageLabel": "KVD8uW_oneClickLuggageLabel",
  "oneClickLuggageOption": "KVD8uW_oneClickLuggageOption",
  "oneClickLuggageOptionSelected": "KVD8uW_oneClickLuggageOptionSelected",
  "oneClickLuggageOptions": "KVD8uW_oneClickLuggageOptions",
  "oneClickLuggagePriceDetail": "KVD8uW_oneClickLuggagePriceDetail",
  "participantDropdown": "KVD8uW_participantDropdown",
  "participantDropdowns": "KVD8uW_participantDropdowns",
  "participantRowWrapper": "KVD8uW_participantRowWrapper",
  "priceDisplayRow": "KVD8uW_priceDisplayRow",
  "roomParticipantsWrapper": "KVD8uW_roomParticipantsWrapper",
  "totalParticipantAmount": "KVD8uW_totalParticipantAmount",
});
